<template>
  <transition name="gate">
    <div class="gate" v-if="gate">
      <div class="gate__container container">
        <img class="gate__logo" src="https://www.mbwsdistribution.lt/themes/degtine/assets/img/logo.png" :alt="this.metaTitle" :title="this.metaTitle" />
        <div class="gate__content" v-if="!rejected">
          <h1 v-text="ui.gate_heading || 'Ar jums daugiau nei 20 metų?'" />
          <div class="gate__actions">
            <div class="gate__action btn" v-text="ui.gate_agree || 'Taip'" @click="setGate(false)"
            />
            <div class="gate__action btn btn--inv" v-text="ui.gate_reject || 'Ne'"
              @click="rejected=true" />
          </div>
        </div>
        <div class="gate__notification" v-else>
          <h3 v-text="ui.gate_reject_text" />
        </div>
        <div class="gate__footer" v-html="ui.gate_footer" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AppGate',
  data() {
    return {
      rejected: false
    }
  },
  computed: {
    ...mapGetters(['baseURL', 'ui', 'gate']),
    metaTitle() {
      if (this.$store.getters.pages._) {
        return this.$store.getters.pages._.meta_title
      }
    }
  },
  methods: {
    ...mapActions(['setGate'])
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/AppGate.vue